import React, { useEffect, useState, useCallback } from 'react';
import PouchDB from 'pouchdb-browser';
import './DownloadedDescription.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  downloadFile,
  formatTypeIcon,
  getTaxon,
  updateResourceDownloadsCount
} from '../functions/functions';
import Star from '../ui/Stars';
import Comment from '../comment/Comment';
import { urls } from '../router/urls';
import axios from 'axios';
import ShareResourceModal from '../ui/ShareResourceModal';
import ResourceViewer from '../ui/ResourceViewer';

const DownloadedDescription = ({
  match: {
    params: { id }
  }
}) => {
  const { t, i18n } = useTranslation();
  const db = PouchDB('gestor_contenidos_db');
  const [datos, setData] = useState({});
  const [locationPath, setLocationPath] = useState('');
  const [fileName, setFileName] = useState('');
  const [fileExtension, setFileExtension] = useState('');
  const [isPhysical, setIsPhysical] = useState(false);
  const [isACorrectLink, setIsACorrectLink] = useState(false);
  const [resourceIsDownloadable, setResourceIsDownloadable] = useState(false);
  const [
    isResourceDownloadAvailable,
    setIsResourceDownloadAvailable
  ] = useState(false);
  const [resourceImage, setResourceImage] = useState('');

  const getFileName = useCallback(object => {
    let file_extension = object.technical[0].format.extension;
    let file_name = object.technical[0].location;
    file_name = file_name.split('/').pop();
    let file = object.slug;
    let fileNameSplit = file_name.split('.');
    if (fileNameSplit.length === 1) {
      file = `${file}.${file_extension}`;
    } else {
      file_extension = fileNameSplit.pop();
      file = `${file}.${file_extension}`;
    }
    setFileName(file);
    setFileExtension(file_extension);
  }, [setFileName, setFileExtension]);

  const getIsResourceDownloadAvailable = useCallback(location => {
    axios
      .get(location)
      .then(response => {
        setIsResourceDownloadAvailable(true);
      })
      .catch(response => {
        setIsResourceDownloadAvailable(false);
      });
  }, [setIsResourceDownloadAvailable]);

  const getObject = useCallback(
    (object, localBlobUrl) => {
      const location = object.technical[0].is_physical
        ? localBlobUrl
        : object.technical[0].get_location_path;
      const physical = object.technical[0].is_physical;
      setLocationPath(location);
      setIsPhysical(physical);
      setIsACorrectLink(object.technical[0].is_a_correct_link);
      setResourceIsDownloadable(object.rights.is_downloadable);
      if (physical) {
        getFileName(object);
        getIsResourceDownloadAvailable(location);
      }
      setResourceImage(
        `url(${process.env.PUBLIC_URL + '/img/external-link-resource.png'})`
      );
    },
    [
      getFileName,
      getIsResourceDownloadAvailable,
      setIsACorrectLink,
      setIsPhysical,
      setLocationPath,
      setResourceImage,
      setResourceIsDownloadable
    ]
  );

  const getData = useCallback(
    () => {
      db.get(id)
        .then(doc => {
          setData(doc);
          db.getAttachment(id, 'resource')
            .then(function(blob) {
              let url = URL.createObjectURL(blob);
              getObject(doc.object, url);
            })
            .catch(function(err) {
              getObject(doc.object);
            });
        })
        .catch(err => {
          if (err === 'not_found') {
            console.log(false);
          }
        });
    },
    [db, id, setData, getObject]
  );

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('lang'));
    getData();
  }, [getData, i18n, id]);

  return (
    <div>
      <div
        style={{ backgroundColor: '#FAC600', width: '100%', height: '12px' }}
      >
        {' '}
      </div>

      {datos.object ? (
        <div>
          {/* Miga de pan */}
          <ol className="breadcrumb m-0">
            <li className="breadcrumb-item bc-link">
              <Link className={'bc-link'} to="/" title={t('inicio')}>
                <i className="fal fa-home"> </i>
                <span> {t('catalogo')}</span>
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link
                className={'bc-link'}
                to={'/' + urls.descargas_recursos}
                title={'dashboard'}
              >
                <i className="fal fa-download"> </i>
                <span> {t('descargas')}</span>
              </Link>
            </li>
            <li className="breadcrumb-item active">
              <span>{datos.object.general.title.value}</span>
            </li>
          </ol>

          <div className="row options">
            <ResourceViewer
              objectId={id}
              locationPath={locationPath}
              isPhysical={isPhysical}
              isACorrectLink={isACorrectLink}
              isResourceDownloadAvailable={isResourceDownloadAvailable}
              fileName={fileName}
              fileExtension={fileExtension}
              resourceImage={resourceImage}
            />
          </div>

          {/* modal comentarios*/}

          <div
            className="modal fade modal-backdrop-transparent modal-valoration"
            aria-modal="true"
            style={{ paddingRight: '15px' }}
          >
            <div className="modal-dialog modal-dialog-right modal-md">
              <div className="modal-content">
                <div className="dropdown-header d-flex justify-content-between align-items-center w-100">
                  <h4 className="m-0 text-secondary font-weight-bold py-3 roboto-pwa">
                    {t('comentario')} ({datos.object.annotation.length || '0'})
                  </h4>
                  <button
                    type="button"
                    className="close text-secondary position-absolute pos-top pos-right p-2 m-1 mr-2 py-3"
                    data-dismiss="modal"
                  >
                    <span>
                      <i className="fal fa-times"> </i>
                    </span>
                  </button>
                </div>
                <div className="modal-body p-0">
                  <div className="settings-panel">
                    {/*cuando se carga el recurso verificar si tiene comentarios*/
                    datos.object.annotation.length ? (
                      datos.object.annotation.map((element, index) => {
                        return (
                          <Comment
                            key={index}
                            stars={element.get_rating}
                            time={element.human_date}
                            description={element.description.value}
                            username={element.user_name}
                          />
                        );
                      })
                    ) : (
                      <h4
                        id="reviewMessage"
                        className="text-center text-secondary fw-500 py-4"
                      >
                        {t('no_comentarios')}
                      </h4>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ShareResourceModal
            resource_id={id}
            url={urls.url_api + datos.object.url}
            quote={datos.object.general.title.value}
          />

          <div className="row">
            <span className="resources-title object-title-pwa">
              {datos.object.general.title.value}
            </span>
          </div>

          <div className="row" style={{ padding: '15px 30px 5px 30px' }}>
            {resourceIsDownloadable && isPhysical ? (
              <div className={'col-sm-3 col-auto '}>
                {/* Descarga de datos de archivo */}
                <button
                  onClick={() => {
                    updateResourceDownloadsCount(id);
                    downloadFile(locationPath, fileName, fileExtension);
                  }}
                  rel="noopener noreferrer"
                  className="fw-400 btn btn-pills btn-white waves-effect waves-themed"
                >
                  <i
                    className="fas fa-cloud-download mr-2"
                    style={{ fontSize: '20px' }}
                  />
                  <span className="download-font">
                    {t('descargar_recurso')}
                  </span>
                </button>
              </div>
            ) : (
              ''
            )}

            {formatTypeIcon(datos.object['technical'][0].format.value) ? (
              <div className={'col-sm-3 col-auto '}>
                <span className="fw-400 btn btn-pills">
                  <i
                    style={{ fontSize: '20px' }}
                    className={
                      formatTypeIcon(datos.object['technical'][0].format.value)
                        .icon + ' format-icon'
                    }
                  />
                  <span className="mx-2">
                    {formatTypeIcon(datos.object['technical'][0].format.value)
                      ? t(
                          formatTypeIcon(
                            datos.object['technical'][0].format.value
                          ).label
                        )
                      : ''}
                  </span>
                </span>
                <div />
              </div>
            ) : (
              ''
            )}
          </div>

          <div className="row tags">
            {datos.object.classification[0].taxon_path.map((tax, index) => (
              <span className={'tags-pwa'} key={index}>
                {tax.level_one[0].value}{' '}
                {index < datos.object.classification[0].taxon_path.length - 1
                  ? ', '
                  : ''}
              </span>
            ))}
          </div>

          <div className={'row options'}>
            <div className="col-sm-4 col-12">
              <div className="stars-icon-pwa mb-3 d-inline">
                <Star rating={datos.object.average_ranking} />
                <span className="stars-pwa fw-900 text-blue">
                  {' ' + datos.object.average_ranking + '.0'}
                </span>
              </div>
            </div>

            <div className="col-sm-4 col-auto link-calificacion">
              <a
                className="options-pwa"
                href={urls.url_api + datos.object['url']}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>{t('califica_recurso')} </span>
                <i className={'fal fa-angle-right'}> </i>
              </a>
            </div>

            <div className={'col-sm-4 col-auto options-pwa link-calificacion'}>
              <button
                className="options-pwa"
                data-toggle="modal"
                data-target=".modal-valoration"
              >
                <span>
                  {datos.object.annotation.length} {t('comentario')}{' '}
                </span>
              </button>
              <i className={'fal fa-angle-right'}> </i>
            </div>
          </div>

          {/* descripcion */}
          <div className="row options">
            <ul className="nav nav-tabs nav-tabs-clean nav-pwa" role="tablist">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  data-toggle="tab"
                  href="#tab-dldesc"
                  role="tab"
                  aria-selected="false"
                >
                  {t('descripcion')}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-toggle="tab"
                  href="#tab-dlsug"
                  role="tab"
                  aria-selected="true"
                >
                  {t('sugerencia_uso_pedagogico')}
                </a>
              </li>
            </ul>

            <div className="tab-content p-3">
              <div
                className="tab-pane fade active show ff-ws"
                style={{ color: '#606060' }}
                id="tab-dldesc"
                role="tabpanel"
                aria-labelledby="tab-home"
              >
                {datos.object.general.description[0].value}
              </div>
              <div
                className="tab-pane fade ff-ws"
                id="tab-dlsug"
                style={{ color: '#606060' }}
                role="tabpanel"
                aria-labelledby="tab-profile"
              >
                {datos.object.general.educational
                  ? datos.object.general.educational.description[0].value
                  : ''}
              </div>
            </div>
          </div>

          {/* grafico */}

          <div className="row grafica-pwa">
            <img
              src={process.env.PUBLIC_URL + '/img/grafica-a.png'}
              alt="logo"
              aria-roledescription="logo"
            />
          </div>

          {/* areas del conocimientp */}

          <div className="row options">
            <h1 className="titles-pwa">
              <div className="mb-3">{t('landing_area_conocimiento')}</div>
              {datos.object.classification.length
                ? getTaxon(datos.object.classification[0].taxon_path).map(
                    (elemento, index) => {
                      return elemento ? (
                        <span
                          key={index}
                          className="keyword badge badge-light badge-pill ff-rb"
                        >
                          {elemento}{' '}
                        </span>
                      ) : (
                        ''
                      );
                    }
                  )
                : ''}
            </h1>
          </div>

          {/* grafico */}

          <div className="row grafica-pwa">
            <img
              src={process.env.PUBLIC_URL + '/img/grafica-b.png'}
              alt="logo"
              aria-roledescription="logo"
            />
          </div>

          {/* Palabras Clave */}

          <div className="row options">
            <h1 className="titles-pwa">
              <div className="mb-3">{t('palabra_clave')}</div>
              {datos.object.general.keyword.length
                ? datos.object.general.keyword[0].value.map(
                    (elemento, index) => {
                      return (
                        <span
                          className="keyword badge badge-light badge-pill ff-rb"
                          key={index}
                        >
                          {' '}
                          {elemento}{' '}
                        </span>
                      );
                    }
                  )
                : ''}
            </h1>
          </div>

          {/* grafico */}

          <div className="row grafica-pwa">
            <img
              src={process.env.PUBLIC_URL + '/img/grafica-c.png'}
              alt="logo"
              aria-roledescription="logo"
            />
          </div>

          {/* Palabras Clave */}

          <div className="row options">
            <h1 className="titles-pwa">
              <div className="mb-3">{t('publico_objetivo')}</div>
              <span className="keyword badge badge-light badge-pill ff-rb">
                {datos.object.educational &&
                  datos.object.educational.intented_end_user_role[0].value}
              </span>
            </h1>
          </div>

          {/* informacion sobre el recurso */}

          <div className="row options-info panel-info-pwa">
            <h5 className="info-pwa col-12 col-md-6">
              {t('tipo_contenido')}:
              <span>
                <small className="mb-0">
                  {datos.object.general.educational
                    ? datos.object.general.educational.learning_resource_type
                        .value
                    : ''}
                </small>
              </span>
            </h5>

            <h5 className="info-pwa col-12 col-md-6">
              {t('licenciante')}:
              <small className="mb-0 text-info-pwa">
                {datos.object.rights
                  ? datos.object.rights.copyright_and_other_restrictions
                      .rights_holder
                  : ''}
              </small>
            </h5>

            <h5 className="info-pwa col-12 col-md-6">
              {t('tipo_licencia')}:
              <span>
                <small className="mb-0">
                  {datos.object.rights
                    ? datos.object.rights.copyright_and_other_restrictions
                        .license
                    : ''}
                </small>
              </span>
            </h5>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default DownloadedDescription;
